import React from "react";
import "../../styles/whychoose.scss";
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Box,
} from '@material-ui/core';

const border = '1px solid #2b84c3';

const styles = {
  container: {
    overflowX: 'auto',
  },
  table: {
    minWidth: 900,
    borderCollapse: 'separate',
    borderSpacing: 0
  },
  headerCell: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '20px',
    padding: '10px',
    fontFamily:'inter',
    borderRight: border,
    borderBottom: 'none',
  },
  featureCell: {
    fontWeight: 600,
    fontSize: '20px',
    padding: '10px',
    fontFamily:'inter',
    width: '25%',
    borderBottom: border,
    textAlign:'center'
  },
  bbysCell: {
    backgroundColor: '#EAF8FF',
    textAlign: 'center',
    padding: '10px',
    borderBottom: border,
    borderRight: border,
    width: '25%',
  },
  dataCell: {
    textAlign: 'center',
    padding: '10px',
    borderBottom: border,
    borderRight: border,
    width: '25%',
  },
};

const features = [
  'Buy and move before you sell',
  'Choose your real estate agent',
  'List and sell for full price',
  'Eliminate home sale contingencies',
  'Submit competitive offers that are more likely to win',
  'Stage and show an empty home',
  'Protect your closing with a backup offer',
];

const data = [
  [true, false, false],
  [true, true, true],
  [true, true, true],
  [true, false, true],
  [true, false, true],
  [true, false, false],
  [true, false, false],
];

const checkIcon = '/assets/images/right_icon.png';

function WhyBbys(props) {
  
  return (
    <div className="bbys-table-main-container inter" id="whyworkwithus">
      <div style={{ textAlign: "center" }}>
        <h2 className="new-heading" style={{ marginBottom: "10px" }}>
          Why{" "}
          <span
            style={{
              color: "#4594CB",
            }}
          >
            Buy-Before-You-Sell
          </span>{" "}
          With Us?
        </h2>
      </div>
     <TableContainer className="why-bbys-table-main-container"  style={styles.container}>
      <Table style={styles.table}>
        <TableHead>
          <TableRow>
            <TableCell style={{ padding: 16 ,borderBottom:'none'}} />
            <TableCell 
              style={{ ...styles.headerCell, backgroundColor: '#EAF8FF',borderTop:border,borderLeft:border,borderRadius:'10px 0px 0px' }} 
              >
               Our BBYS
            </TableCell>
            <TableCell style={{...styles.headerCell,borderTop:border,}}>Traditional Mortgage</TableCell>
            <TableCell
            className={styles.headerCell}
              style={{
                ...styles.headerCell,
                borderRight: border,
                borderTopRightRadius: '10px',
                borderTop:border,
              }}
            >
              iBuyers
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {features.map((feature, index) => (
            <TableRow key={index}>
              <TableCell
                style={{
                  ...styles.featureCell,
                  borderLeft: border,
                  ...(index === 0 ? { borderTopLeftRadius: 10,borderTop:border } : {}),
                  ...(index === features.length - 1 ? { borderBottomLeftRadius: 10, } : {}),
                }}
              >
                {feature}
              </TableCell>
              <TableCell
                style={{
                  ...styles.bbysCell,
                  ...(index === 0 ? { borderTop: border } : {}),
                  ...(index === features.length - 1 ? { borderBottom: border , borderLeft:border, } : {borderLeft:border}),
                }}
              >
                {data[index][0] && (
                  <img
                    src={checkIcon}
                    alt="check"

                  />
                )}
              </TableCell>
              <TableCell style={{
                 ...(index === 0 ? { borderTop: border } : {}),
                 ... styles.dataCell}}>
                {data[index][1] && (
                  <img
                    src={checkIcon}
                    alt="check"
                   
                  />
                )}
              </TableCell>
              <TableCell
                style={{
                  ...styles.dataCell,
                  ...(index === 0 ? { borderTop: border } : {}),
                  ...(index === features.length - 1
                    ? { borderBottomRightRadius: 10 }
                    : {}),
                }}
              >
                {data[index][2] && (
                  <img
                    src={checkIcon}
                    alt="check"
                   
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
  );
}

export default WhyBbys;
